module.exports = __webpack_public_path__ + "9ef5a36bf825ff3792af2f1b4f0a9799.png";